import React from "react";
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from "uuid";
import { kazooLoggerCreator } from "kazoologger";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

let userId = localStorage.getItem("kazoologId");
// console.log(userId);
if (userId === null) {
  userId = uuidv4();
  localStorage.setItem("kazoologId", userId);
}

export const kazooLog = kazooLoggerCreator({
  APIKEY: "750624db-1eac-4c43-997b-2ed1f8c1c61b",
  userId: userId,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
